import React, { useState } from "react";
import { Card, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Spin } from "antd";
import toast from "react-hot-toast";
import { createVehicule } from "../../services/vehiculeApi";
import DownloadExcelModel from "./ExcelModel";
import FileUpload from "./FileUpload";
import ExcelJS from "exceljs";

const AddVehMass = ({ modal, setModal, toggle }) => {
  const [vehiclesData, setVehiclesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleAcceptedFiles = (files) => {
    const file = files[0];

    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    });

    setSelectedFiles([file]);

    const reader = new FileReader();
    reader.onload = async (e) => {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(e.target.result);

      const worksheet = workbook.worksheets[0];
      const vehicles = [];

      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        if (rowNumber === 1) return;

        const marque = row.getCell(1).value;
        const modele = row.getCell(2).value;
        const numeroPlaque = row.getCell(3).value;
        const dateMiseEnService = row.getCell(4).value;
        const kilometrage = row.getCell(5).value;
        const vitesse = row.getCell(6).value;
        const transmission = row.getCell(7).value;
        const statut = row.getCell(8).value;
        const vin = row.getCell(9).value;

        if (!marque || !modele || !numeroPlaque) {
          toast.error(`Ligne ${rowNumber + 1}: Veuillez remplir les champs obligatoires.`);
          return;
        }

        vehicles.push({
          brand: marque,
          model: modele,
          registrationNumber: numeroPlaque,
          commissioningDate: dateMiseEnService,
          mileage: kilometrage,
          speed: vitesse,
          transmission: transmission,
          statut: statut,
          vin: vin,
        });
      });

      if (vehicles.length === 0) {
        toast.error("Aucune donnée valide à ajouter.");
      } else {
        setVehiclesData(vehicles);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const promises = vehiclesData.map(async (vehicle) => createVehicule(vehicle));
      await Promise.all(promises);
      toast.success("Véhicules ajoutés avec succès 🎉");
      setModal(false);
    } catch (error) {
      toast.error("Erreur lors de l'ajout des véhicules : " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop={"static"} style={{ maxWidth: "800px" }}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        Ajout en masse des véhicules par un fichier excel
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <DownloadExcelModel />
            </Col>
            <Col lg={6}>
              <FileUpload selectedFiles={selectedFiles} handleAcceptedFiles={handleAcceptedFiles} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button className="bordered-btn" color="light" onClick={() => setModal(false)}>
              Annuler
            </Button>
            <Button type="submit" className="active-tab" disabled={isLoading || vehiclesData.length === 0}>
              {isLoading ? "Chargement..." : "Ajouter les véhicules"}
              {isLoading && <Spin />}
            </Button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default AddVehMass;
